MachinesContractMainController.$inject = []
function MachinesContractMainController(){
}

export default MachinesContractMainController